import React from 'react';
import PropTypes from 'prop-types';
import { useTable, useFlexLayout } from 'react-table';

export const SimpleTable = ({ id, data, columns }) => {
    const defaultColumn = React.useMemo(
        () => ({
            // When using the useFlexLayout:
            minWidth: 30, // minWidth is only used as a limit for resizing
            width: 150, // width is used for both the flex-basis and flex-grow
            maxWidth: 200 // maxWidth is only used as a limit for resizing
        }),
        []
    );
    const { getTableProps, rows, prepareRow } = useTable(
        {
            data,
            columns,
            defaultColumn
        },
        useFlexLayout
    );
    const dataTableProps = {
        id,
        label: ''
    };

    return (
        <div {...dataTableProps} {...getTableProps()} className="table">
            <div className="tbody">
                {rows.map((row, i) => {
                    prepareRow(row);
                    return (
                        <div key={i} {...row.getRowProps()} className="tr">
                            {row.cells.map((cell) => (
                                // eslint-disable-next-line react/jsx-key
                                <div {...cell.getCellProps()} className="td">
                                    {cell.render('Cell')}
                                </div>
                            ))}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SimpleTable;

SimpleTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    id: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.object)
};
